import React from 'react';

export default function Pricing(props) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        version="1.1"
        {...props}
      >
        <title>Pricing icon</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Upcoming-Webinar-Templates"
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Upcoming-Webinar-Template-01"
            transform="translate(-902.000000, -934.000000)"
          >
            <g id="Form" transform="translate(833.000000, 210.000000)">
              <g id="Demo_Card">
                <g id="Info" transform="translate(69.000000, 722.000000)">
                  <g
                    id="Pricing-icon"
                    transform="translate(0.000000, 2.000000)"
                  >
                    <circle id="Oval-3" fill="#60D956" cx={15} cy={15} r={15} />
                    <path
                      d="M22.0651384,7.86771138 C23.4286849,9.21354945 22.897433,14.5437765 22.3838895,15.6239887 C21.7640957,16.9521183 17.8328319,20.9896325 14.5744871,23.7167255 C14.4151115,23.8583926 14.2026108,23.9292262 13.99011,23.9292262 C13.5651085,23.9292262 13.3880246,23.7698506 13.0869818,23.6104751 C12.4494796,23.2740156 10.5546813,22.2292202 9.13800963,20.7948402 C7.89842194,19.5729609 6.97758536,18.0146221 6.49945868,17.2000359 C6.18070756,16.6156588 5.73799767,15.9427398 6.19841596,15.3583627 C8.81925851,12.0291844 12.9984399,8.18646251 14.3088611,7.54896026 C14.9994886,7.23020914 16.7703281,7 18.3995005,7 C19.6922134,7 21.3568026,7.14166716 22.0651384,7.86771138 Z M18.3109586,11.8166836 C18.9307524,12.3656439 19.8870058,12.3125187 20.4536744,11.6927248 C21.0026347,11.072931 20.9495095,10.1166776 20.3297157,9.55000897 C19.7099218,9.0010487 18.7536684,9.05417389 18.1869998,9.67396774 C17.6380395,10.2937616 17.6911647,11.2500149 18.3109586,11.8166836 Z M12.6088552,18.7583747 C13.9369848,19.8385868 14.8932382,19.8385868 15.5838656,19.1479594 C16.5224106,18.191706 15.778658,17.0229519 14.8755298,15.7833642 C14.3442779,15.0041948 14.2734444,14.8271109 14.5567787,14.5437765 C14.7869878,14.3135674 15.1411557,14.384401 15.6192824,14.8625276 C15.9911587,15.2166956 16.2213679,15.5177383 16.4161602,15.8364894 C16.5755358,16.1021153 16.8765785,16.2969077 17.124496,16.2791993 L17.5672059,16.2260741 C17.7974151,16.2083657 17.8682487,15.9604482 17.7265815,15.6948222 C17.5317891,15.3583627 17.2661632,14.9864864 16.9474121,14.6146101 L17.5317891,14.0125247 C17.6734563,13.8708575 17.6026227,13.5698148 17.3724136,13.3396056 L17.0005373,12.9677293 C16.7703281,12.7552286 16.4692854,12.684395 16.3276182,12.8260622 L15.7432412,13.4281476 C14.6807375,12.5781446 13.7067757,12.3479355 12.9807315,13.0916881 C12.1307285,13.9593995 12.6796888,15.0041948 13.5828169,16.2791993 C14.1317772,17.0583687 14.2734444,17.3239946 13.9546932,17.6604542 C13.6536505,17.9437885 13.2817742,17.8729549 12.6088552,17.2177443 C12.1838537,16.7927428 11.8296858,16.2969077 11.5463514,15.7833642 C11.4046843,15.5354467 11.1036415,15.3406543 10.9088492,15.3937795 L10.4307225,15.4646131 C10.2005134,15.5177383 10.1296798,15.7479474 10.2890553,16.0135734 C10.5369729,16.4917 10.9088492,17.0406603 11.3869759,17.5719122 L10.855724,18.103164 C10.7140568,18.2625396 10.7848904,18.5635823 11.0150996,18.7760831 L11.3869759,19.1479594 C11.617185,19.3781685 11.9182277,19.4490021 12.0598949,19.3073349 L12.6088552,18.7583747 Z"
                      id="pricetag"
                      fill="#FFFFFF"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Pricing/index.js